import { render, staticRenderFns } from "./myPwdChange.vue?vue&type=template&id=361331be&scoped=true&"
import script from "./myPwdChange.vue?vue&type=script&lang=js&"
export * from "./myPwdChange.vue?vue&type=script&lang=js&"
import style0 from "./myPwdChange.vue?vue&type=style&index=0&id=361331be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361331be",
  null
  
)

export default component.exports